/* ============================================================
   Craft Com — envoi des fichiers du devis vers WhatsApp
   WhatsApp (wa.me) ne peut transporter que du texte : les fichiers
   sont donc envoyés sur Firebase Storage, et leurs liens de
   téléchargement sont ajoutés au message WhatsApp.
   Se charge APRÈS app.js (réutilise sa validation et son message).
   ============================================================ */
(function () {
  var MAX_FILES = 6;
  var MAX_SIZE = 20 * 1024 * 1024; // 20 Mo par fichier

  function storage() {
    try {
      if (window.firebase && firebase.apps && firebase.apps.length && firebase.storage) return firebase.storage();
    } catch (e) {}
    return null;
  }

  function safeName(n) {
    return String(n).normalize('NFD').replace(/[̀-ͯ]/g, '')
      .replace(/[^a-zA-Z0-9._-]+/g, '_').slice(-80) || 'fichier';
  }

  function uploadAll(files) {
    var st = storage();
    if (!st) return Promise.reject(new Error('Storage indisponible'));
    var folder = 'devis/' + Date.now() + '-' + Math.random().toString(36).slice(2, 10);
    var list = Array.prototype.slice.call(files, 0, MAX_FILES);
    return Promise.all(list.map(function (f) {
      if (f.size > MAX_SIZE) return Promise.resolve({ name: f.name, url: null, tooBig: true });
      var ref = st.ref(folder + '/' + safeName(f.name));
      return ref.put(f, { contentType: f.type || 'application/octet-stream' })
        .then(function (snap) { return snap.ref.getDownloadURL(); })
        .then(function (url) { return { name: f.name, url: url }; })
        .catch(function () { return { name: f.name, url: null }; });
    }));
  }

  function waitingPage(win) {
    try {
      win.document.write('<!doctype html><meta name="viewport" content="width=device-width,initial-scale=1">' +
        '<title>Envoi…</title><body style="margin:0;height:100vh;display:flex;align-items:center;justify-content:center;' +
        'background:#05080a;color:#2fe6e0;font-family:Montserrat,Arial,sans-serif;text-align:center;padding:20px">' +
        '<div><div style="font-size:1.1rem;font-weight:700">Envoi de vos fichiers…</div>' +
        '<div style="color:#9aa;margin-top:8px;font-size:.9rem">WhatsApp va s\'ouvrir automatiquement.</div></div></body>');
      win.document.close();
    } catch (e) {}
  }

  var sending = false;
  document.addEventListener('click', function (e) {
    if (e.target && e.target.closest && e.target.closest('#sendBtn')) {
      sending = true;
      setTimeout(function () { sending = false; }, 0);
    }
  }, true);

  var origOpen = window.open;
  window.open = function (url) {
    var fi = document.getElementById('f-file');
    var isWa = typeof url === 'string' && url.indexOf('https://wa.me/') === 0;
    if (!sending || !isWa || !fi || !fi.files || !fi.files.length) {
      return origOpen.apply(window, arguments);
    }
    sending = false;

    // Ouvre l'onglet tout de suite (sinon le navigateur bloque la pop-up après l'upload)
    var win = origOpen.call(window, '', '_blank');
    if (win) waitingPage(win);

    var base = url.split('?text=')[0];
    var text = decodeURIComponent(url.split('?text=')[1] || '');
    var files = fi.files;

    uploadAll(files).then(function (res) {
      var lines = ['', '📎 *Fichiers joints :*'];
      res.forEach(function (r, i) {
        if (r.url) lines.push((i + 1) + '. ' + r.name + '\n' + r.url);
        else lines.push((i + 1) + '. ' + r.name + (r.tooBig ? ' (trop lourd, à envoyer ici)' : ' (à envoyer ici)'));
      });
      if (files.length > MAX_FILES) lines.push('+ ' + (files.length - MAX_FILES) + ' autre(s) fichier(s) à envoyer ici.');
      return lines.join('\n');
    }).catch(function () {
      return '\n📎 ' + files.length + ' fichier(s) à envoyer dans la conversation.';
    }).then(function (block) {
      // remplace la ligne "📎 N fichier(s) à envoyer…" générée par app.js
      var cleaned = text.replace(/\n*📎 \d+ fichier\(s\) à envoyer dans la conversation\./, '');
      var finalUrl = base + '?text=' + encodeURIComponent(cleaned + '\n' + block);
      if (win && !win.closed) { try { win.opener = null; } catch (e) {} win.location.href = finalUrl; }
      else location.href = finalUrl;
    });

    return win;
  };
})();
